import React from 'react'
import { UiCol, UiSingleRow } from "../../../components/grid-container/GridContainer"
import London from "../../../../../styles/img/london-img.jpg"
import { UiButtonPrimary, UiButtonSecondary } from "../../../components/form/UiButton"

import {
    UiPointBreakDownWr,
    UiPointBreakDownCol,
    UiPointBreakDownHr,
    UiPointBreakDownBtnWr
} from "../../../components/common/UiProductElements"
import { useNavigate } from "react-router-dom";

export default function CartPointSection(props) {

    let navigate = useNavigate();
    const onClick = () => {
        let path = `../../ui/voucher-wallet`;
        navigate(path);

    }

    return (
        <>

            <UiPointBreakDownWr>
                <UiPointBreakDownCol colName="Points Cost" amount="250K Points" />
                <UiPointBreakDownCol colName="Cash Top Up" amount="£50" />
                <UiPointBreakDownHr />
                <UiPointBreakDownCol colName="Points Total" amount="300k Points" />
                <UiPointBreakDownHr />
                <UiPointBreakDownBtnWr>
                    <UiButtonPrimary btnName={`Buy Now ${'250K Points + £50'}`} disabled={false} onClick={onClick} />
                    <UiButtonPrimary btnName="Make a Change" />
                    
                </UiPointBreakDownBtnWr>
            </UiPointBreakDownWr>


        </>
    )
}

